<template>
  <div class="rules-container">
    <Modal
      :mask-closable="false"
      title
      @on-cancel="closePay"
      v-model="visible"
      width="400"
      class-name="vertical-center-modal wechat-modal"
    >
      <div class="pay_content">
        <div class="t1">微信支付</div>
        <div class="t2">支付金额</div>
        <div class="t3">¥{{ money }}</div>
        <div class="qrcode_wrap">
          <img class="qrcode" :src="qrcodeImg" />
          <div class="over_time" v-if="needRefresh" @click="refreshDoPay()">
            <div class="refresh">
              <img src="../../assets/image/icon/pay_refresh.png" class="pay_refresh" />
              刷新
            </div>
          </div>
        </div>
        <div class="t4">
          <img src="../../assets/image/icon/scanIcon.png" class="scanIcon" />
          打开手机微信 扫一扫二维码
        </div>
        <div class="time">
          <img src="../../assets/image/icon/countDownIcon.png" class="countDownIcon" />
          {{ min }}:{{ sec }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import QRCode from "qrcode";
import wxSdk from "weixin-js-sdk";
export default {
  name: "WechatPay",
  data() {
    return {
      visible: false,
      endTime: "",
      qrcodeImg: "",
      diffTime: 1 * 60 * 1000,
      min: "",
      needRefresh: false,
      sec: "",
      payId: null,
      loading: false,
      orderId: null,
      type: null,
      isWeixin: false
    };
  },
  props: {
    money: {
      type: [String, Number],
      default: ""
    }
  },
  mounted() {
    var ua = window.navigator.userAgent.toLowerCase();
    let openId = this.$store.state.gzhOpenId;
    if (openId == null || openId == "") {
      openId = this.getQueryVariable("openid");

      if (openId != null) {
        this.$store.commit("setValue", ["gzhOpenId", openId]);
      }
    }
    this.openId = openId;

    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWeixin = true;
      let code = this.getQueryVariable("code");
      // console.log(code)
      //checkoutPay?cartItems=d7099d7a320b46498cda6b1cbc7ae5cb&amp%3B%3B%3B%3B%3B%3B%3BorderId=960e015da3bd4f9687bcc766f1f05e9e&amp%3B%3B%3B%3B%3B%3B%3Bcode=091DCtGa186vJB0XN8Ja1hwsZc1DCtG5&amp%3B%3B%3B%3B%3B%3B%3Bstate=123&amp%3B%3B%3B%3B%3B%3Bopenid=oqnnu50WO0LuFmERiP3FJHiU2fK4&amp%3B%3B%3B%3B%3B%3Bcode=051hqI100qbgoM1KLz100N9lyS0hqI1r&amp%3B%3B%3B%3B%3B%3Bstate=123&amp%3B%3B%3B%3B%3Bopenid=oqnnu50WO0LuFmERiP3FJHiU2fK4&amp%3B%3B%3B%3B%3Bcode=001K4h0w3aJW4X2A8i2w3e1OzP1K4h0v&amp%3B%3B%3B%3B%3Bstate=123&amp%3B%3B%3B%3Bopenid=oqnnu50WO0LuFmERiP3FJHiU2fK4&amp%3B%3B%3B%3Bcode=091RzcGa182MJB0vSpJa1TXchm4RzcGd&amp%3B%3B%3B%3Bstate=123&amp%3B%3B%3Bopenid=oqnnu50WO0LuFmERiP3FJHiU2fK4&amp%3B%3B%3Bcode=011qhT000Jk5pM1uiZ100KqQFp4qhT0g&amp%3B%3B%3Bstate=123&amp%3B%3Bopenid=oqnnu50WO0LuFmERiP3FJHiU2fK4&amp%3B%3Bcode=011WqnFa1ubBKB0TCJHa1et6UJ1WqnFl&amp%3B%3Bstate=123&amp%3Bopenid=oqnnu50WO0LuFmERiP3FJHiU2fK4&amp%3Bcode=051AeC0006nmpM1Bc1000ADsGT0AeC0y&amp%3Bstate=123&openid=oqnnu50WO0LuFmERiP3FJHiU2fK4&response_type=code&scope=snsapi_base&state=123&uin=MjE2MjUzMzgwNw%3D%3D&key=740e7be0ecee7b047d93ec138be226a96abec39597de033eae0e96e562e43f9e630496b2e180e09ceb64106199ae21d2&pass_ticket=RHitj2qHSYFAhxnL8rg50eZRo2HT1QjmJUSw6f6GHXY9Gj%20W3ycon90P2bTjJ9VWZfOnpJA3lvqlfgAqhZjJnw%3D%3D
      this.code = code;
      // return;
      if (openId == null && code == null) {
        this.getOpenId();
      } else if (openId == null) {
        this.initWeixin();
      }
    } else {
      this.isWeixin = false;
    }

    this.checkPay();
  },
  methods: {
    closePay() {
      this.payId = null;
    },
    getOpenId() {
      let redirect_uri = encodeURIComponent(window.location.href);
      //oqnnu50WO0LuFmERiP3FJHiU2fK4
      // let redirect_uri = "https://tb-test.getconnectplus.com/"
      let appid = this.$store.state.appid;
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appid +
        "&redirect_uri=" +
        redirect_uri +
        "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
    },
    initWeixin() {
      //  let url = encodeURIComponent( "https://tb-test.getconnectplus.com/")
      let url = encodeURIComponent(window.location.href);
      let code = this.code;
      // let entityId = "9d1a363e-5350-4123-a8a7-90da23ce2f53";
      let entityId = this.$store.state.entityId;
      let uri = `https://scrm.getconnectplus.com/scrm/v1/oauth/callback/${entityId}?backurl=${url}&code=${code}`;

      window.location.href = uri;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return null;
    },
    getQueryVariableDecode(variable) {
      let search = decodeURIComponent(window.location.search).replace(
        /amp;/g,
        ""
      );
      var query = search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return null;
    },
    isMobile() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkPay() {
      if (this.payId != null) {
        let merchantId = this.$store.state.storeId;
        let url =
          this.$store.state.API.pay.wechatCheck + `${merchantId}/${this.payId}`;
        this.$http.get(url, {}).then(res => {
          if (res.status == 200 && res.data.message == "success") {
            if (res.data.returnData == "PAYED") {
              this.payId = null;
              this.visible = false;
              this.$emit("paysuccess");
              this.$Message.success("支付成功");
              this.$router.push({
                name: "order-list",
                params: {},
                query: { weChatPaidId: this.orderId }
              });
            } else {
              setTimeout(() => {
                this.checkPay();
              }, 3000);
            }
          }
        });
      } else {
        setTimeout(() => {
          this.checkPay();
        }, 3000);
      }
    },
    countdown() {
      const end = this.endTime;
      const now = new Date().getTime();
      const msec = end - now;
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      if (min >= 0 && sec >= 0) {
        if (min == 0 && sec == 0) {
          this.needRefresh = true;
          this.payId = null;
          return;
        }
        setTimeout(() => {
          this.countdown();
        }, 1000);
      }
    },
    refreshDoPay() {
      this.doPay(this.orderId, this.type);
    },
    startWeiXinPay(pay_params) {
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady(pay_params),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent(
            "WeixinJSBridgeReady",
            this.onBridgeReady(pay_params)
          );
          document.attachEvent(
            "onWeixinJSBridgeReady",
            this.onBridgeReady(pay_params)
          );
        }
      } else {
        this.onBridgeReady(pay_params);
      }
    },

    onBridgeReady(pay_params) {
      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: pay_params.appId, // 公众号名称，由商户传入
          timeStamp: pay_params.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: pay_params.nonceStr, // 随机串
          package: pay_params.packageStr, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: pay_params.signType, // 微信签名方式：
          paySign: pay_params.paySign // 微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            alert("支付成功");
          } else {
            alert("支付失败");
          }
        }
      );
    },
    doPay(orderId, type) {
      // alert(type)
      this.orderId = orderId;
      this.type = type;
      if (this.loading) {
        return;
      }
      this.loading = true;
      let merchantId = this.$store.state.storeId;
      let isH5 = this.isMobile();

      let typeStr = null;

      if (this.type == "WECHAT") {
        if (this.isWeixin) {
          typeStr = "WECHAT_PAY_GZ";
          if (orderId == null || orderId == "") {
            orderId = this.getQueryVariableDecode("orderId");
          }
       
        } else if (isH5) {
          typeStr = "WECHAT_PAY_H5";
        } else {
          typeStr = "WECHAT_PAY_PC";
        }
      } else {
        if (isH5) {
          typeStr = "ALI_PAY_H5";
        } else {
          typeStr = "ALI_PAY_PC";
        }
      }

      let params = {};
      let url =
        this.$store.state.API.pay.wechatPay +
        `${merchantId}/${orderId}/${typeStr}`;
      if (typeStr == "WECHAT_PAY_GZ") {
        url = url + "?openId=" + this.openId;
      }
    //  alert(url)
      this.$http.get(url, params).then(res => {
        if (res.status == 200 && res.data.message == "success") {
          let returnData = res.data.returnData;
          this.payId = returnData.payId;
          let payUrl = returnData.payUrl;
          // console.log(returnData);
          if (typeStr == "WECHAT_PAY_GZ" && this.type == "WECHAT") {
            this.startWeiXinPay(returnData);
          } else if (!isH5 && this.type == "WECHAT") {
            QRCode.toDataURL(payUrl)
              .then(qrUrl => {
                this.qrcodeImg = qrUrl;
                this.needRefresh = false;
                this.endTime = new Date().getTime() + this.diffTime;
                this.visible = true;

                this.countdown();
                this.checkPay();
              })
              .catch(err => {
                console.error(err);
              });
          } else if (this.type == "ALIPAY") {
            // alert(payUrl)
            const div = document.createElement("div");
            div.innerHTML = payUrl;
            div.id = "aliPayWrap";
            document.body.appendChild(div);
            document
              .getElementById("aliPayWrap")
              .querySelector("form")
              .submit();
          } else {
            window.location.href = payUrl;
          }
        } else {
          this.$Message.error(res.data.message);
        }
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}
/deep/.wechat-modal .ivu-modal-content {
  // min-width: 58.2rem;
  max-width: 100vw;
  height: 40rem;
  background-color: #fff;
  margin: auto;
  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: center;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
/deep/.wechat-modal .ivu-modal-body {
  padding: 0 2rem;
  width: 100%;
  box-sizing: border-box;
  .pay_content {
    .t1 {
      display: flex;
    }
    .t2 {
      margin-top: 1rem;
      font-size: 1.2rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5c5d5f;
      line-height: 1.7rem;
    }
    .t3 {
      margin-top: 1rem;
      font-size: 1.2rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #5c5d5f;
      line-height: 1.7rem;
    }

    .qrcode_wrap {
      margin: 0 auto;
      margin-top: 1rem;
      width: 17.2rem;
      height: 17.2rem;
      position: relative;
      .qrcode {
        width: 100%;
        height: 100%;
      }
      .over_time {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        top: 0rem;
        left: 0rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .refresh {
          cursor: pointer;
          width: 6.3rem;
          height: 2.5rem;
          background: #ffffff;
          align-items: center;
          display: flex;
          font-size: 1.2rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #5c5d5f;
          .pay_refresh {
            width: 1.6rem;
            height: 1.6rem;
            margin-left: 0.7rem;
            margin-right: 0.7rem;
          }
        }
      }
    }
    .t4 {
      margin-top: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5c5d5f;
      .scanIcon {
        width: 1.3rem;
        height: 1.3rem;
        margin-right: 1.2rem;
      }
    }
    .time {
      margin-top: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5c5d5f;
      line-height: 1.7rem;
      .countDownIcon {
        width: 1.1rem;
        height: 1.1rem;
        margin-right: 0.3rem;
      }
    }
  }
}
/deep/.ivu-modal-mask {
  background-color: rgba(55, 55, 55, 0);
}
/deep/.ivu-modal-close {
  display: initial;
}
/deep/.wechat-modal {
  background-color: rgba(0, 0, 0, 0.5);
}
@media screen and (max-width: 1024px) {
  /deep/.wechat-modal .ivu-modal-content {
    width: calc(100% - 4rem);
  }
}
@media screen and (max-width: 768px) {
  .wechat-modal .ivu-modal-body .qrcode-title-en {
    margin-bottom: 2.5rem;
  }
  .wechat-modal .ivu-modal-body .qrcode-title-en p {
    font-size: 1.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pay.vue